function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// A reimplementation of `ViewMore` from `fe-co-expander` to suit Allhomes needs
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Expander, expandable } from '@domain-group/fe-co-expander';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './view-more.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ViewMore = props => {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDisabledOnMount = _useState2[0],
    setDisabledOnMount = _useState2[1];
  var handleInitialHeight = height => {
    if (height < props.expandedHeight) {
      setDisabledOnMount(true);
    }
  };
  var isDisabled = props.isDisabled || isDisabledOnMount;
  return ___EmotionJSX("div", {
    className: props.className,
    css: styles.wrapper
  }, ___EmotionJSX(Expander, {
    expanded: props.expanded,
    expandedHeight: isDisabled ? undefined : props.expandedHeight,
    expandedText: props.expandedText,
    contractedText: props.contractedText,
    isDisabled: isDisabled,
    onInitialHeight: handleInitialHeight,
    isGradient: !isDisabled
  }, props.children({
    expanded: props.expanded
  })), !isDisabled && ___EmotionJSX(Button, {
    css: styles.button,
    size: "small",
    appearance: "secondaryNeutral",
    onClick: props.onExpandToggle
  }, props.expanded ? props.expandedText : props.contractedText));
};
ViewMore.propTypes = {
  expandedHeight: PropTypes.number,
  expandedText: PropTypes.string,
  contractedText: PropTypes.string,
  isDisabled: PropTypes.bool,
  children: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired,
  onExpandToggle: PropTypes.func.isRequired,
  className: PropTypes.string
};
ViewMore.defaultProps = {
  expandedHeight: 100,
  expandedText: 'View less',
  contractedText: 'View more',
  isDisabled: false,
  className: ''
};
export default expandable(ViewMore.defaultProps.expandedHeight)(ViewMore);